import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { URLSearchParams } from "@angular/http";
import { HomeService } from './home.service';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { LoginUserService } from '../../core/services/login-user.service';
import { MessageService } from '../../core/services/message.service';
import 'rxjs/add/operator/switchMap';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  providers: [HomeService],
})
export class HomeComponent implements OnInit {



  public jobsList: Array<any> = [];        //岗位列表
  public jobPage: any;                //岗位分页
  public couEmployList: Array<any> = [];   //课程信息
  public optionType: string = null;
  public queryObj: Object = {};
  public aa: string = "这是标题";
  public keyhotWrod: string;//关键字
  public linkUrl: Object = {};//分页链接；
  public userType: any;//用户角色
  public hotInfoList: Array<Object> = [];//热门资讯列表
  public setOption: Array<string>;// 设置配置项
  constructor(
    public _jobHomeService: HomeService,
    public _router: Router,
    public _routeActive: ActivatedRoute,
    public _login: LoginUserService,
    private _msg: MessageService,
    private _title: Title,
    private _meta: Meta
  ) {
    this._title.setTitle( 'X直聘-实习就业' );
    this._meta.updateTag( { name: 'Keywords', content: '大学生实习，实习报告，实习心得，个人简历模板，C实习。' } );
    this._meta.updateTag( {
      name: 'Description',
      content: `C实习为大学实习生提供全方位的就业支持。通过职业评测，在线课程，实训实战任务，电商大赛等方式提高大学生能力，获得相应的技能勋章，
      完成能力认证。同时帮助大学实习生做好:职业规划、个人简历制作，实习报告、实习心得等等，服务于职场新人，提升综合就业能力。`
    } );
  }

  ngOnInit() {
    this.setOption = ['city_id', 'education_id', 'nature_id', 'jobType', 'salary_id', 'industry_id', 'position_industry_pid', 'position_industry_cid'];
    window.scrollTo(0, 0);//页面回到顶部
    //首页漏油带过的参数解析并请求响应数据
    this._routeActive.queryParams.subscribe(params => {
      // console.log("params", params);
      this.queryObj = JSON.parse(JSON.stringify(params));


      params['keyword'] ? this.keyhotWrod = params['keyword'] : this.keyhotWrod = '';
      this.getJobListData(); //获取岗位列表信息
    });
    //热门资讯列表
    this.getHotList();

    if (this._login.isLogin()) {
      let userInfo = this._login.getLoginInfo();
      this.userType = userInfo['type'] + '';
    }
  }



  //编辑简历接口   dfasdda
  editResume() {
    if (this._login.isLogin()) {
      let userInfo = this._login.getLoginInfo();
      this.userType = userInfo['type'] + '';
      if (this.userType === '1') {
        this._router.navigate(['/user/student/student-edit']);
      } else {
        this._msg.warn('请登录您的账号');
        this._router.navigate(['/user-info/login-register']);  //登陆页面
      }
    } else {
      this._msg.warn('请登录您的学生账号');
    }
    setTimeout(() => {
      this._msg.clear();
    }, 3000);
  }

  //set岗位id
  setpositionId(cid, pid) {
    // console.log(1);
    // this.queryObj['position_industry_id'] = cid === 0 ? pid : cid;
    // console.log(2);

    // delete this.queryObj['position_industry_cid'];
    // delete this.queryObj['position_industry_pid'];
  }

  // 岗位列表接口 实习就业首页岗位搜索接口
  getJobListData(page?: number) {
    let tmp;
    if (this.queryObj['position_industry_cid'] && this.queryObj['position_industry_cid'] > 0) {
      tmp = this.queryObj['position_industry_cid'];
    }
    else if (this.queryObj['position_industry_pid']) {
      tmp = this.queryObj['position_industry_pid'];
    }

    let params = new URLSearchParams();
    for (let option in this.queryObj) {
      if (option === 'position_industry_pid' || option === 'position_industry_cid') {
        continue;
      }
      params.append(option, this.queryObj[option]);
    }
    tmp && params.append('position_industry_id', tmp);
    // console.log("heheh", this.queryObj);
    page && params.append('page', page.toString());
    this._jobHomeService.getjobListData(params.toString()).then(resp => {
      if (resp.success) {
        this.jobsList = resp['data'];
        this.jobsList.map(row => {
          row.welfare == '' ? row.welfare = null : row.welfare = row.welfare.split(","); //福利数据处理
          // if (row.welfare) {
          //   row.welfare.splice(row.welfare.findIndex(rec => rec === ''), 0);
          // }
        })
        this.jobPage = resp['pagination']['pageCount'];//分页信息
      }
    });
  }


  // 岗位筛选条件
  getCateOption(event) {
    let tmpEvent = Object.assign({}, event);
    let keyword = this.queryObj['keyword'];
    let tmpParams;
    if (!keyword) {
      tmpParams = Object.assign({}, tmpEvent);
    } else {
      tmpParams = Object.assign({ keyword: keyword }, tmpEvent)
    }
    this._router.navigate(['/job'], { queryParams: tmpParams });
  }


  //获取输入的关键字  并获取响应岗位数据
  getKeyWorld(event) {
    // console.log("aaa", event);
    this.keyhotWrod = event;  //得到关键字'
    this._jobHomeService.getSimilar(this.keyhotWrod).then();
    this._router.navigate(['/job'], { queryParams: { keyword: this.keyhotWrod } });
  }
  //或取到热门关键字 并获取响应岗位数据
  getHoutWord(event) {
    // console.log("sss", event);
    // this.keyhotWrod = event.name;  //得到关键字
    this.getKeyWorld(event.name);
  }
  //分页
  paginate(event: Object) {
    let pages = event['page'] + 1;
    this.getJobListData(pages);
  }
  // getJobId(event: any) {
  //   // console.log("job-home", event);
  //   this._router.navigate(['/job/detail/', event]);
  // }
  // getCompanyId(event: any) {
  //   this._router.navigate(['/job/company/', event]);
  // }




  // public hotInfoList: Array<Object> = [];
  //热门资讯列表
  getHotList() {
    this._jobHomeService.getHotInfoList().then(resp => {
      if (resp.success) {
        this.hotInfoList = resp['data'];
      }
    })
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/job/home/home.component.ts